import { render, staticRenderFns } from "./PaymentMethodConfigList.vue?vue&type=template&id=274e70a6"
import script from "./PaymentMethodConfigList.vue?vue&type=script&lang=js"
export * from "./PaymentMethodConfigList.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodConfigList.vue?vue&type=style&index=0&id=274e70a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports